module.exports = __webpack_public_path__ + "img/activities-15.4e9a3376.jpg";